import { isRoleAtLeast, UserRole } from "@/utils/roleManager";

const normalizeUserRole = (userRole: string): UserRole | null => {
  return Object.values(UserRole).includes(userRole as UserRole) ? (userRole as UserRole) : null;
};

export const userHasPermission = (
  currentUserRole: UserRole,
  minimumRequired: UserRole,
): boolean => {
  return isRoleAtLeast(currentUserRole, minimumRequired);
};

export const isCraveUser = (userRole: string): boolean => {
  const normalizedRole = normalizeUserRole(userRole);
  return normalizedRole
    ? [UserRole.CRAVE_ADMIN, UserRole.CRAVE_PRIVILEGE, UserRole.CRAVE_EMPLOYEE].includes(
        normalizedRole,
      )
    : false;
};

const isCustomerAdmin = (userRole: string): boolean => {
  return normalizeUserRole(userRole) === UserRole.CUSTOMER_ADMIN;
};

// Hook for checking permissions
export const usePermission = (userRole: string) => {
  const normalizedRole = normalizeUserRole(userRole);

  return {
    userHasPermission: (minimumRequired: UserRole) =>
      normalizedRole ? userHasPermission(normalizedRole, minimumRequired) : false,
    isCraveUser: () => isCraveUser(userRole),
    isCustomerAdmin: () => isCustomerAdmin(userRole),
  };
};
